const OBSERVER_API = process.env.REACT_APP_OBSERVER_API_ENDPOINT;

export async function isUserAuthenticated() {
  if (process.env.NODE_ENV === "development") return true;
  const response = await fetch(`${OBSERVER_API}/me`, {
    // const response = await fetch(`http://emily.yieldbooster.io:9000/me`, {
    credentials: "include",
  })
    .then(function (response) {
      return response.ok;
    })
    .catch(function (error) {
      throw error;
    });

  return await response;
}
